export enum StringMatchType {
    Equals,
    StartsWith,
    EndsWith,
    Contains,
}
export const StringMatchTypeReverse = {
    0: 'Equals',
    1: 'Starts with',
    2: 'Ends with',
    3: 'Contains',
}
